import classNames from 'classnames';
import EcoImg from 'eco-design/base/eco-img';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoLink from 'eco-design/base/eco-link';

// 默认用户头像
const defaultUserIcon = 'https://websiteoss.ecoflow.com/upload/image/1735782674645/logo.svg';
export default function BlogCategoryBCard({ layout = 'text-hover', ...item }: any) {
    const prefixCls = `blog-category-b-card`;
    const classes = classNames(prefixCls, {
        [`${prefixCls}-layout-${layout}`]: layout,
    });
    const itemStyleComp = {
        '--blog-item-titleColor': item.titleColor,
        '--blog-item-labelColor': item.labelColor,
    } as React.CSSProperties;

    return (
        <div className={classes} style={itemStyleComp}>
            <EcoLink href={item.href} className={`${prefixCls}-img`}>
                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} />
            </EcoLink>
            <div className={`${prefixCls}-msg`}>
                <EcoLink href={item.categoryHref} className={`${prefixCls}-label`}>
                    {item.label}
                </EcoLink>
                <EcoLink href={item.href} className={`${prefixCls}-title`}>
                    {item.title}
                </EcoLink>
                <div className={`${prefixCls}-footer`}>
                    <div className={`${prefixCls}-footer-icon`}>
                        <EcoImg pc={item.userIcon || defaultUserIcon} />
                    </div>
                    <div className={`${prefixCls}-footer-logo`}>{item.userName || 'EcoFlow'}</div>
                    <div className={`${prefixCls}-footer-time`}>- {item.timer}</div>
                </div>
            </div>
        </div>
    );
}
